import * as React from 'react';

import { Progress } from '@longline/aqua-ui/controls/Progress';

import { useGlobalState } from '../contexts/state/GlobalStateContext';
import { ELayerType } from '../types/ELayerType';
import { GridProcessor } from '../GridProcessor';
import { useOrganixContext } from './IOrganixContext';
import { OrganixStatus } from './OrganixStatus';
import { IOrganixGridPoint } from '../types/IOrganixGridPoint';

interface IProps {
  onComplete: (data: IOrganixGridPoint[]) => void;
  canvas: HTMLCanvasElement;
}

const OrganixProcessor = (props: IProps) => {
  const ctx = useOrganixContext();
  const globalState = useGlobalState();
  
  // Current export progress percentage:
  const [progress, setProgress] = React.useState<number>(0);

  // Lsat update time:
  const lastUpdateRef = React.useRef(0);

  const handleProgress = (percentDone: number) => {
    const now = performance.now();

    // Always show 100% immediately.
    if (percentDone >= 100) {
      setProgress(100);
      lastUpdateRef.current = now;
      return;
    }

    // Throttle: only update every 100ms:
    const THROTTLE_MS = 100;

    if (now - lastUpdateRef.current >= THROTTLE_MS) {
      setProgress(percentDone);
      lastUpdateRef.current = now;
    }
  }

  const handleCompleteProcessing = (data: IOrganixGridPoint[]) => {
    props.onComplete(data);
  }

  const getFactor = () => {
    let factor = 1;
    let width = ctx.simulation.area.resolution * factor;
    while(width < 200) {
      factor++;
      width = ctx.simulation.area.resolution * factor;
    }
    return factor;
  }

  // Canvas is not immediately ready on first render.
  // Use local state to sigal readiness to <Source>.
  React.useEffect(() => {
    // Give canvas a chance to get ready.
    setTimeout(() => {
      const canvasContext = props.canvas.getContext('2d');
      if (!canvasContext) return;
      // TODO: Warn about missing depth or current layers.
      const exp = new GridProcessor(canvasContext,
        globalState.structures, ctx.simulation.area,
        globalState.layers.find(l => l.type == ELayerType.Depth),
        globalState.layers.find(l => l.type == ELayerType.CurrentSpeed),
        getFactor(), handleProgress, handleCompleteProcessing);
      exp.run();
      }, 100);
  }, []);

  return (
    <OrganixStatus>
      Calculating ORGANIX grid...
      <Progress width="300px" thickness={8} numbered value={progress}/>
    </OrganixStatus>
  )
}

export { OrganixProcessor }
